import { styled, Card } from '@mui/material';

import Flexbox from 'layouts/flexbox/Flexbox';
import theme from 'core/ThemeConstants';

const ModalContainer = styled(Card)(({ maxwidth }) => ({
  top: '50%',
  left: '50%',
  maxWidth: maxwidth,
  minWidth: 200,
  zIndex: 100,
  position: 'absolute',
  padding: '1.5rem',
  boxShadow: theme.boxShadows.default,
  transform: 'translate(-50%, -50%)',
  width: '100%',
  overflow: 'unset !important',
}));

const ModalToolbar = styled(Flexbox)(() => ({
  justifyContent: 'flex-end',
  width: '100%',
  marginTop: '4rem',
  gap: '0 1rem',
}));

export { ModalToolbar };
export default ModalContainer;
